var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider as MuiThemeProvider, StylesProvider, createGenerateClassName, } from '@material-ui/core/styles';
import withStyles from '@material-ui/core/styles/withStyles';
import themes from './themes';
var GlobalCss = withStyles(function () { return ({
    // @global is handled by jss-plugin-global.
    '@global': {
    // You should target [class*="MuiButton-root"] instead if you nest themes.
    },
}); })(function () { return null; });
var ThemeLayout = function (_a) {
    var children = _a.children, seed = _a.seed, productionPrefix = _a.productionPrefix, _b = _a.theme, theme = _b === void 0 ? themes.base : _b;
    var stylesProviderProps = __assign({ injectFirst: true }, (seed && {
        generateClassName: createGenerateClassName({
            seed: seed,
            productionPrefix: productionPrefix,
        }),
    }));
    return (React.createElement(MuiThemeProvider, { theme: theme },
        React.createElement(CssBaseline, null),
        React.createElement(GlobalCss, null),
        React.createElement(StylesProvider, __assign({}, stylesProviderProps), children)));
};
export default ThemeLayout;
//# sourceMappingURL=ThemeLayout.js.map